import OAuth2 from '../oauth2/OAuth2.esm.js';

const DEFAULT_PROVIDER = {
  id: "google",
  title: "Google",
  icon: () => null
};
const SCOPE_PREFIX = "https://www.googleapis.com/auth/";
class GoogleAuth {
  static create(options) {
    const {
      configApi,
      discoveryApi,
      oauthRequestApi,
      environment = "development",
      provider = DEFAULT_PROVIDER,
      defaultScopes = [
        "openid",
        `${SCOPE_PREFIX}userinfo.email`,
        `${SCOPE_PREFIX}userinfo.profile`
      ]
    } = options;
    return OAuth2.create({
      configApi,
      discoveryApi,
      oauthRequestApi,
      provider,
      environment,
      defaultScopes,
      scopeTransform(scopes) {
        return scopes.map((scope) => {
          if (scope === "openid") {
            return scope;
          }
          if (scope === "profile" || scope === "email") {
            return `${SCOPE_PREFIX}userinfo.${scope}`;
          }
          if (scope.startsWith(SCOPE_PREFIX)) {
            return scope;
          }
          return `${SCOPE_PREFIX}${scope}`;
        });
      }
    });
  }
}

export { GoogleAuth as default };
//# sourceMappingURL=GoogleAuth.esm.js.map
